/* unplugin-vue-components disabled */import script from "./RefundTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefundTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./RefundTableBlock.vue?vue&type=style&index=0&id=1b8a6272&scoped=true&lang=less"
import "./RefundTableBlock.vue?vue&type=style&index=1&id=1b8a6272&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8a6272"]])

export default __exports__